/**
 * Shared inbox styling — used by both the per-company InboxView (ViewRenderer)
 * and the cross-company PortfolioPage. Category badges and severity dots must
 * look identical whether you're inside one company or seeing the whole practice.
 */

export const CATEGORY_BADGE: Record<string, string> = {
  Deadline: 'bg-red-100 text-red-700',
  OverdueInvoice: 'bg-amber-100 text-amber-700',
  UnmatchedPayment: 'bg-sky-100 text-sky-700',
  PayrollAccrual: 'bg-slate-100 text-slate-700',
  Finding: 'bg-gray-100 text-gray-600',
};

export const SEVERITY_DOT: Record<string, string> = {
  Critical: 'bg-red-500',
  Error: 'bg-red-500',
  Warning: 'bg-amber-500',
  Info: 'bg-sky-500',
};

/** Per-company dot colors (stable across sessions — hashed from workspace id). */
const COMPANY_COLORS = ['bg-blue-500', 'bg-emerald-500', 'bg-orange-500', 'bg-slate-500', 'bg-cyan-600', 'bg-teal-600'];

export function companyColor(workspaceId: string): string {
  let hash = 0;
  for (let i = 0; i < workspaceId.length; i++) hash = (hash * 31 + workspaceId.charCodeAt(i)) | 0;
  return COMPANY_COLORS[Math.abs(hash) % COMPANY_COLORS.length] ?? COMPANY_COLORS[0]!
}

/** Server-side category rank (mirrors GetAttentionInboxHandler.CategoryRank). */
export const CATEGORY_ORDER: Record<string, number> = {
  Deadline: 0,
  OverdueInvoice: 1,
  UnmatchedPayment: 2,
  PayrollAccrual: 3,
  Finding: 4,
};
